import { Injectable } from "@angular/core";

@Injectable()
export class SessionStorageService {
  setItem(key: string, value: any) {
    if (typeof value == "object") value = JSON.stringify(value);

    window.sessionStorage.setItem(key, value);
    return this;
  }

  getItem(key: string, defaultValue: any = null) {
    let response = window.sessionStorage.getItem(key);
    if (response == null) return defaultValue;

    return response;
  }
  getItemAsJsonObject(key: string) {
    return JSON.parse(this.getItem(key));
  }

  removeItem(key: string): void {
    window.sessionStorage.removeItem(key);
  }
}
